import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';

export interface SftpProcessedFile {
  id: number;
  fileName: string;
  remotePath: string;
  fileSize: number;
  checksum?: string;
  status: 'PROCESSING' | 'PROCESSED' | 'FAILED';
  s3Paths?: string;
  errorMessage?: string;
  createdAt: string;
  processedAt?: string;
  updatedAt?: string;
}

export interface SpringPage<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface SftpProcessResult {
  scanned: number;
  processed: number;
  skipped: number;
  failed: number;
  s3Paths: string[];
}

@Injectable({ providedIn: 'root' })
export class SftpApi {
  constructor(private readonly http: HttpClient) {}

  findAll(page: number, size: number, search: string): Observable<SpringPage<SftpProcessedFile>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (search) params = params.set('search', search);
    return this.http.get<SpringPage<SftpProcessedFile>>('/sftp/v1/files', { params }).pipe(timeout(30000));
  }

  upload(files: File[]): Observable<SftpProcessResult> {
    const data = new FormData();
    files.forEach(file => data.append(files.length === 1 ? 'file' : 'files', file, file.name));
    return this.http.post<SftpProcessResult>('/sftp/v1/files', data).pipe(timeout(120000));
  }
}
